import { snowtrade } from "../../../../api";

export const sendAcceptOptionRequest = (leadId) =>
  snowtrade.patch(`/api/sales/leads/${leadId}/property/option/accept`);

export const sendDeclineOptionRequest = (leadId) =>
  snowtrade.patch(`/api/sales/leads/${leadId}/property/option/decline`);
